<script>
    import Vue from 'vue';
    import { mapState } from 'vuex';
    import Spinner from 'framework/components/loaders/spinning-loader/spinning-loader';

    export default {
        props: {
            component: {
                type: Function,
                default: () => Promise.resolve(Vue.extend({ template: `<mark>No component was found</mark>` })),
            },
        },
        data() {
            return {
                componentInstance: null,
            };
        },
        computed: {
            ...mapState('page', ['isLoading']),
        },
        mounted() {
            this.component().then(instance => {
                if (this.wasDestroied) {
                    return;
                }

                this.componentInstance = instance.__esModule ? instance.default : instance;
            });
        },
        beforeDestroy() {
            this.wasDestroied = true;
        },
        render(createElement) {
            if (this.componentInstance && !this.isLoading) {
                return createElement(this.componentInstance);
            }

            return createElement('div', {
                class: 'page lazy-route',
            }, [createElement(Spinner)]);
        },
    };
</script>
